import React, {useMemo} from 'react';
import Link from 'next/link';
import styled from 'styled-components';

import ContentWrapper from 'components/contentWrapper';
import Icon from 'components/icons/icon';

import ProductTabs from 'components/pages/product/productTabs';

import theme, {bp, color} from 'settings/theme';


type Props = {
  product: any,
  activeTab: string
};

// Product Header
const Component: React.FC<Props> = (props) => {

  console.log('product', props.product);

  const bookUrl = useMemo(() => {
    return (props.product?.content?.book_appointment_url && props.product?.content?.book_appointment_url !== '') ? props.product?.content?.book_appointment_url : 'https://calendly.com/wheelfreedom-showroom?utm_source=productpage';
  }, [props.product]);

  return (
    <StyledComponent className="productMenu">
        <ContentWrapper fullWidthAt={[1,2]} className="productMenu-contentWrapper">

          <div className="productMenu-layout">

            {/* Tabs */}
            <div className="productMenu-layout-tabs">
              <ProductTabs product={props.product} activeTab={props.activeTab} />
            </div>

            {/* Buttons */}
            <div className="productMenu-layout-buttons">
              <div className="productMenu-buttons">

                <Link href="/contact" passHref>
                  <button className="productMenu-buttons-button">
                    TALK TO AN EXPERT<Icon iconName="chevron" iconDirection="right" />
                  </button>
                </Link>

                <Link href={bookUrl} target="_blank" className="productMenu-buttons-button">
                  BOOK AN APPOINTMENT<Icon iconName="chevron" iconDirection="right" />
                </Link>

              </div>
            </div>

          </div>

        </ContentWrapper>
    </StyledComponent>

  );

}


export default Component;




// Styles
const StyledComponent = styled.div`

  position: -webkit-sticky; /* Safari */
  position: sticky;
  top: 59px;

  height: 40px;
  border-top: solid 1px ${color.lines};
  border-bottom: solid 1px ${color.lines};
  background-color: white;

  .productMenu-contentWrapper{
    height: 100%;
  }

  .productMenu-layout{
    display: flex;
    align-items: stretch;
    justify-content: space-between;
    width: 100%;
    height: 100%;
  }

  .productMenu-layout-buttons{
    flex: 1 1 auto;
    display: none;
    max-width: 500px;
  }

  .productMenu-buttons{
    display: flex;
    align-items: stretch;
    justify-content: space-evenly;
    height: 100%;
  }

  .productMenu-buttons-button{

    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    margin-left: 20px;
    color: ${color.primary};
    font-family: ${theme.typography.fontFamilySecondary};
    font-size: 12px;
    font-weight: bold;
    white-space: nowrap;
    transition: all 0.15s ease-out;

    span{
      display: none;
    }

    .icon{

      width: 10px;
      height: 10px;
      margin-left: 5px;

      svg{
        fill: ${color.primary};
      }

    }

    &:hover{
      opacity: 0.5;
    }

  }

  @media (min-width: ${bp(3)}) {

    .productMenu-layout-buttons{
      display: block;
    }

    .productMenu-buttons-button{

      span{
        display: block;
      }

      .icon{
        width: 10px;
        height: 10px;
        margin-left: 5px;
      }

    }

  }

  @media (min-width: ${bp(4)}) {

    top: 139px;
    height: 60px;

    .productMenu-buttons-button{

      font-size: 14px;

      .icon{
        width: 10px;
        height: 10px;
        margin-left: 5px;
      }

    }

  }


    /* @media (min-width: ${bp(4)}) {

      height: 60px;

      .productMenu-buttons-button{

        font-size: 14px;

        .icon{
          width: 10px;
          height: 10px;
          margin-left: 5px;
        }

      }

    } */


`;



